import {getIsKilnConfigValid} from '@hconnect/kilnfeature/src/helpers'
import {Loader} from '@hconnect/uikit/src/lib2'
import {Stack, Typography, Alert, Button, Link} from '@mui/material'
import {KilnSvgWrapper} from '@widgets/kms'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router'

import {useGetAssetConfig} from '../../hooks/assetConfig/useGetAssetConfig'

import {getUrl, PLANT_ROUTES, useUrlParam} from '@settings/modules/routing'

interface AssetLayoutProps {
  assetId: string
}

export const AssetLayout: React.FC<AssetLayoutProps> = ({assetId}) => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  const plantCode = useUrlParam('plantCode')

  const {data: kilnConfig, isLoading, error} = useGetAssetConfig(assetId)

  if (isLoading) return <Loader />

  const isKilnConfigMissing = !kilnConfig || error?.response?.status === 404
  const layoutExists = kilnConfig !== undefined && Object.keys(kilnConfig.payload.layout).length > 0

  const kilnConfigValid =
    !isKilnConfigMissing &&
    getIsKilnConfigValid(kilnConfig.payload.layout, kilnConfig.payload.configuration)
      .isKilnConfigValid

  return (
    <Stack display="flex" flexDirection="column" gap={3} flexGrow={1} maxWidth="1200px">
      {layoutExists && (
        <KilnSvgWrapper
          sensorMappings={[]}
          kilnInfo={{
            id: kilnConfig.metadata.typeUpmId,
            // @ts-expect-error we know layout inner elements
            layout: kilnConfig.payload.layout,
            isRotationClockwise: kilnConfig.payload.layout['isRotationClockwise'],
            isStopped: false
          }}
        />
      )}
      <Alert
        elevation={4}
        severity={isKilnConfigMissing ? 'error' : !kilnConfigValid ? 'warning' : 'info'}
        sx={{
          borderRadius: '4px'
        }}
        action={
          <Button
            variant="contained"
            color="primary"
            size="small"
            component={Link}
            onClick={() =>
              navigate(getUrl(PLANT_ROUTES.KILN_CONFIG.path, {plantCode, kilnId: assetId}))
            }
          >
            {t('kilnConfig.setUpKiln')}
          </Button>
        }
      >
        <Typography variant="body1">
          {isKilnConfigMissing
            ? t('kilnConfig.createKilnConfigAlert')
            : !kilnConfigValid
              ? t('kilnConfig.invalidKilnConfigAlert')
              : t('kilnConfig.updateKilnConfigAlert')}
        </Typography>
      </Alert>
    </Stack>
  )
}
